import {
  useCurrentChatSession,
  useCurrentChatSessionWidgetSnapshots,
} from "@/data/chat-history";
import type {
  ChatHistoryDetailSession,
  ChatHistoryWidgetSnapshot,
} from "@/lib/apis/web/chat-history-api";

export function useDirectChatSessionSubscription({
  sessionId,
  projectId,
  enabled,
}: {
  sessionId: string | null;
  projectId: string | null;
  enabled: boolean;
}) {
  const session = useCurrentChatSession(
    enabled && sessionId
      ? ({
          sessionId,
          projectId: projectId ?? undefined,
        } as const)
      : "skip",
  ) as
    | (ChatHistoryDetailSession & { turnInFlight?: boolean })
    | null
    | undefined;

  const widgetSnapshots = useCurrentChatSessionWidgetSnapshots(
    enabled && sessionId ? ({ sessionId } as const) : "skip",
  ) as ChatHistoryWidgetSnapshot[] | undefined;

  // Note: turnTraces are intentionally NOT subscribed here. They're fetched
  // once per thread via the REST /chat-history/detail seed path and retained
  // in liveTraceState for the lifetime of the session. On a reactive refresh
  // we pass `undefined` for turnTraces to loadChatSession, which treats it as
  // "preserve existing trace state" rather than wiping it. This keeps the
  // component safe to render when the paired backend function isn't deployed.
  return { session, widgetSnapshots };
}
